import type { DashboardLayout, Permission } from '@proerp/shared';
import { DASHBOARD_WIDGETS } from './registry';
import type { DashboardWidgetDef } from './types';

type Can = (permission: Permission) => boolean;

/** Widgets, die der Nutzer laut Berechtigung überhaupt sehen darf. */
export function permittedWidgets(can: Can): DashboardWidgetDef[] {
  return DASHBOARD_WIDGETS.filter((widget) => !widget.requiredPermission || can(widget.requiredPermission));
}

/**
 * Erlaubte Widgets in der gespeicherten Reihenfolge: bekannte (erlaubte) IDs zuerst
 * in Nutzer-Reihenfolge, danach neu hinzugekommene erlaubte Widgets in Registry-
 * Reihenfolge ans Ende (analog `resolveNavGroupOrder`) — so verschwindet ein neues
 * Widget nie und ein weggefallenes/gesperrtes wird ignoriert.
 */
export function resolveWidgetOrder(savedOrder: string[], can: Can): DashboardWidgetDef[] {
  const permitted = permittedWidgets(can);
  const byId = new Map(permitted.map((widget) => [widget.id, widget]));
  const known = savedOrder
    .map((id) => byId.get(id))
    .filter((widget): widget is DashboardWidgetDef => Boolean(widget));
  const knownIds = new Set(known.map((widget) => widget.id));
  const rest = permitted.filter((widget) => !knownIds.has(widget.id));
  return [...known, ...rest];
}

/** Tatsächlich anzuzeigende Widgets: aufgelöste Reihenfolge minus ausgeblendete. */
export function visibleWidgets(layout: DashboardLayout, can: Can): DashboardWidgetDef[] {
  const hidden = new Set(layout.hidden);
  return resolveWidgetOrder(layout.order, can).filter((widget) => !hidden.has(widget.id));
}
